module.exports = __webpack_public_path__ + "static/media/spinButton.56f2059f.svg";